/**
 * @format
 */

import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

import { BusinessHour } from '../../api/adserver';
import config from '../../lib/config';

export interface Props {
  item: BusinessHour;
}

const HourListItem: React.FC<Props> = (props) => {
  return (
    <>
      <View style={[styles.container]}>
        <Text style={[styles.time, styles.text]}>{props.item.day_name}</Text>
        <Text style={[styles.value, styles.text]}>{props.item.open_hours}</Text>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 0,
    paddingHorizontal: 0,
    flex: 1,
    flexDirection: 'row',
    marginBottom: 5,
    justifyContent: 'space-between',
  },
  text: {
    fontSize: 11,
    color: config.theme.advert.subSectionHeadingTextColor,
  },
  time: {},
  value: {},
});

export default HourListItem;
